import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoadingService } from './loading.service';
import { Router } from '@angular/router';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUrl = this.router.url;

    if (currentUrl.includes('/users/' ) || currentUrl.includes('/userdata')) {

        this.loadingService.show();

        return next.handle(req).pipe(
          finalize(() => this.loadingService.hide())
        );
    }

    return next.handle(req);
  }
}